import bowser from 'bowser';

const browser = bowser.getParser(window.navigator.userAgent);

export const isValidBrowser = () => {
    return browser.satisfies({
        chrome: ">63",
        firefox: ">56",
        "internet explorer": ">10",
        safari: ">10",
        "Microsoft Edge": ">11"
    });
};
